import { Transition as TransitionBase } from "@headlessui/react";
import React, { forwardRef, Fragment } from "react";
import type { ReactNode } from "react";

export type ListBoxProps = {
  className?: string;
} & React.HTMLAttributes<HTMLUListElement>;

const ListBox_ = forwardRef(function ListBox(
  props: ListBoxProps,
  ref: React.LegacyRef<HTMLUListElement>,
) {
  const { className = "", ...others } = props;
  return (
    <ul
      ref={ref}
      className={`absolute z-10 mt-1 max-h-60 w-full overflow-auto rounded bg-white py-1 shadow-lg ${className}`}
      {...others}
    />
  );
});

const Option = forwardRef(function Option(
  props: React.HTMLAttributes<HTMLLIElement>,
  ref: React.LegacyRef<HTMLLIElement>,
) {
  const { className = "", ...others } = props;
  return (
    <li
      ref={ref}
      className={`ui-active:bg-gray-200 px-3 py-2 ${className}`}
      {...others}
    />
  );
});

const Transition = ({ children }: { children: ReactNode }) => (
  <TransitionBase
    as={Fragment}
    enter="transition ease-out duration-150"
    enterFrom="transform opacity-0 scale-90"
    enterTo="transform opacity-100 scale-100"
    leave="transition ease-in duration-100"
    leaveFrom="transform opacity-100 scale-100"
    leaveTo="transform opacity-0 scale-90"
  >
    {children}
  </TransitionBase>
);

const NoOption = (props: React.HTMLAttributes<HTMLLIElement>) => {
  const { className = "", children = "No options", ...others } = props;
  return (
    <li
      className={`select-none px-3 py-2 text-gray-700 ${className}`}
      {...others}
    >
      {children}
    </li>
  );
};

export const ListBox = Object.assign(ListBox_, {
  Option,
  Transition,
  NoOption,
});
